/**
 * 系统设置API服务
 * 
 * @author CodeArts代码智能体
 * @date 2026-04-18
 */

import api from '../../api';
import type { Result } from '../../types';

export const getProfile = (): Promise<Result<Record<string, unknown>>> => {
  return api.get('/users/profile');
};

export const updateProfile = (data: Record<string, unknown>): Promise<Result<void>> => {
  return api.put('/users/profile', data);
};

export const changePassword = (data: Record<string, unknown>): Promise<Result<void>> => {
  return api.put('/users/password', data);
};

export const getNotificationSettings = (): Promise<Result<Record<string, unknown>>> => {
  return api.get('/users/notification-settings');
};

export const updateNotificationSettings = (data: Record<string, unknown>): Promise<Result<void>> => {
  return api.put('/users/notification-settings', data);
};

export const getSystemSettings = (): Promise<Result<Record<string, unknown>>> => {
  return api.get('/users/system-settings');
};

export const updateSystemSettings = (data: Record<string, unknown>): Promise<Result<void>> => {
  return api.put('/users/system-settings', data);
};
